import { Note, NoteType, NotePriority } from '../../../../../types/api';
import { useNotesQuery } from '../../statistics.queries';

interface UseNotesHistoryParams {
  droneSerial?: string;
  startDate?: string;
  endDate?: string;
  noteType?: NoteType;
  priority?: NotePriority;
  includeResolved?: boolean;
}

// Thin wrapper over the TanStack `useNotesQuery` (STD-015/016). Server state and
// cross-component refresh are handled by the query cache: note mutations
// invalidate `statisticsKeys.notes(droneSerial)` in their onSuccess, so this
// query auto-refetches — no more `window` CustomEvent bus or manual local state.
export const useNotesHistory = (params: UseNotesHistoryParams) => {
  const query = useNotesQuery(params.droneSerial, {
    startDate: params.startDate,
    endDate: params.endDate,
    noteType: params.noteType,
    priority: params.priority,
    includeResolved: params.includeResolved,
  });

  const notes: Note[] = query.data ?? [];

  return {
    notes,
    loading: query.isLoading,
    error: query.isError ? 'Failed to load notes' : null,
    refreshNotes: () => {
      query.refetch();
    },
  };
};
